import { Divider, Grid, Link, Stack, Typography } from "@mui/material";
import { IconButton } from "components/Elements/Buttons/IconButton";

import { NicaIconWhite } from "components/Elements/Buttons/NicaIconWhite";

export const Footer: React.FC = () => {
  return (
    <Grid
      container
      justifyContent={{ xs: "center", md: "space-around" }}
      p={4}
      sx={{
        backgroundColor: "primary.main",
      }}
    >
      <Grid item xs={12} md={4} textAlign={{ xs: "center", md: "left" }}>
        <IconButton
          disableRipple
          sx={{ marginRight: 5, margin: 0 }}
          href="https://nica.com/"
        >
          <NicaIconWhite
            viewBox="0 0 160.93 134.42"
            sx={{ height: 90, width: 200 }}
          />
        </IconButton>
      </Grid>
      <Grid item xs={12} md={8}>
        <Stack
          direction="column"
          justifyContent={{ xs: "center", md: "flex-start" }}
          alignItems={{ xs: "center", md: "flex-end" }}
          divider={<Divider sx={{ borderColor: "primary.light", width: '100%' }} />}
          spacing={2}
        >
          <Grid item mt={{ xs: 2, md: 0 }}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent={{ xs: "center", md: "flex-start" }}
              alignItems={{ xs: "center", md: "flex-end" }}
              spacing={2}
            >
              <Link
                href="https://nica.com/contact/"
                sx={{ textTransform: "none", color: "white", fontFamily: "Lato", pr: { xs: 0, md: 2 } }}
              >
                Contact Us
              </Link>
              <Link
                href="https://nica.com/about-nica/#faq"
                sx={{ textTransform: "none", color: "white", fontFamily: "Lato", pl: { xs: 0, md: 2 } }}
              >
                FAQ
              </Link>
            </Stack>
          </Grid>
          <Grid container item>
            <Grid container justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Typography color={"white"} sx={{ textAlign: { xs: "center", md: "left" } }}>
                  The Florida Birth-Related Neurological Injury Compensation
                  Association
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography color={"white"} sx={{ textAlign: { xs: "center", md: "right" } }}>
                  {'\u00A9'} 2025 NICA. All Rights Reserved.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Stack>
      </Grid>
    </Grid>
  );
};
